import React from "react";

import FormInput from "../../Inputs/FormInput";
import FormSelect from "../../Inputs/FormSelect";
import Button from "../../Button";

import { getDimensionFieldMeta, UNIT_OPTIONS } from "./pageModal.utils";
import styles from "./pageModal.module.css";

const PART_TYPE_OPTIONS = [
  { label: "Circle", value: "circle" },
  { label: "Square", value: "square" },
  { label: "Rectangle", value: "rectangle" },
];

const PartManagementModalForm = ({
  formFields,
  formData,
  errors,
  readOnly,
  partSpecificationRows,
  getFieldLabel,
  normalizeSelectValue,
  handleChange,
  handlePartSpecificationChange,
  addPartSpecificationRow,
  removePartSpecificationRow,
}) => {
  const partFields = formFields.filter((field) => field.section === "Part Details");

  return (
    <>
      <div className={styles.formSection}>
        <h3 className={styles.sectionTitle}>Part Details</h3>
        <div className={styles.formGrid}>
          {partFields.map((field) => {
            if (field.type === "select") {
              return (
                <FormSelect
                  key={field.name}
                  label={getFieldLabel(field)}
                  name={field.name}
                  value={formData[field.name] || ""}
                  options={field.options || []}
                  error={errors[field.name]}
                  disabled={readOnly || field.disabled}
                  onChange={(e) =>
                    handleChange(field.name, normalizeSelectValue(field, e.target.value))
                  }
                />
              );
            }

            return (
              <FormInput
                key={field.name}
                label={getFieldLabel(field)}
                name={field.name}
                type={field.type}
                decimalPlaces={field.type === "number" ? 2 : undefined}
                error={errors[field.name]}
                accept={
                  field.type === "file" ? ".png,.jpg,.jpeg,application/pdf" : undefined
                }
                value={field.type !== "file" ? formData[field.name] || "" : undefined}
                disabled={readOnly || field.disabled}
                onChange={(e) => {
                  if (field.type === "file") {
                    handleChange(field.name, e.target.files[0]);
                  } else {
                    handleChange(field.name, e.target.value);
                  }
                }}
              />
            );
          })}
        </div>
      </div>

      <div className={styles.formSection}>
        <div className={styles.partHeaderRow}>
          <h3 className={styles.sectionTitle}>Part Type</h3>
          {!readOnly && (
            <Button
              type="button"
              variant="primary"
              className="h-25"
              onClick={addPartSpecificationRow}
            >
              <i className="bi bi-plus-lg"></i>
            </Button>
          )}
        </div>

        {errors.part_specifications && (
          <div className={styles.partRowError}>{errors.part_specifications}</div>
        )}

        {partSpecificationRows.map((row, rowIndex) => {
          const dimensionFields = getDimensionFieldMeta(row.part_type);
          return (
            <div key={`part-spec-row-${rowIndex}`} className={styles.partRowGrid}>
              <FormSelect
                label="Part Type"
                name={`part_type_${rowIndex}`}
                value={row.part_type || ""}
                options={PART_TYPE_OPTIONS}
                error={errors[`part_specifications_${rowIndex}_part_type`]}
                disabled={readOnly}
                onChange={(e) =>
                  handlePartSpecificationChange(rowIndex, "part_type", e.target.value)
                }
              />

              {[0, 1, 2].map((slotIndex) => {
                const field = dimensionFields[slotIndex];
                if (!field) {
                  return (
                    <FormInput
                      key={`dimension-slot-${rowIndex}-${slotIndex}`}
                      label=""
                      type="number"
                      decimalPlaces={2}
                      value=""
                      disabled
                    />
                  );
                }

                return (
                  <FormInput
                    key={`${field.name}_${rowIndex}`}
                    label={field.label}
                    type="number"
                    decimalPlaces={2}
                    value={row[field.name] || ""}
                    disabled={readOnly || !row.part_type}
                    onChange={(e) =>
                      handlePartSpecificationChange(rowIndex, field.name, e.target.value)
                    }
                  />
                );
              })}

              <FormSelect
                label="Unit"
                name={`unit_${rowIndex}`}
                value={row.unit || ""}
                options={UNIT_OPTIONS}
                disabled={readOnly || !row.part_type}
                onChange={(e) =>
                  handlePartSpecificationChange(rowIndex, "unit", e.target.value)
                }
              />
              <FormInput
                label="Volume"
                type="number"
                decimalPlaces={2}
                value={row.volume || ""}
                disabled
              />
              <FormInput
                label="Rate"
                type="number"
                decimalPlaces={2}
                value={row.rate || ""}
                disabled={readOnly}
                onChange={(e) =>
                  handlePartSpecificationChange(rowIndex, "rate", e.target.value)
                }
              />

              {!readOnly && (
                <div className={styles.partDeleteCell}>
                  <Button
                    type="button"
                    variant="primary"
                    onClick={() => removePartSpecificationRow(rowIndex)}
                    className="w-25 h-25"
                  >
                    <i className="bi bi-dash-lg"></i>
                  </Button>
                </div>
              )}
            </div>
          );
        })}
      </div>
    </>
  );
};

export default PartManagementModalForm;
